import { useIntl } from 'react-intl';

import { Text } from '@calm-web/design-system';

import messages from '@/components/emotion-detector/messages';

import { EmptyContainer, EmptyPrompt } from '../styles';

export default function EmptyState() {
	const { formatMessage } = useIntl();

	return (
		<EmptyContainer>
			<Text el="p">{formatMessage(messages.emptyTitle)}</Text>
			<EmptyPrompt>
				<Text color="gray8">{formatMessage(messages.emptyPrompt)}</Text>
			</EmptyPrompt>
		</EmptyContainer>
	);
}
